import { ROLES } from "../routes/role.constants";

export const sidebarMenu = [
  {
    title: "Application",
    items: [
      {
        label: "Home",
        to: "/",
        icon: "vaadin:home-o",
        roles: [
          ROLES.ADMIN_SYS,
          ROLES.ADMIN_ESCOLAR,
          ROLES.MENTOR,
          ROLES.ESTUDIANTE,
        ],
      },
      {
        label: "Dashboard",
        to: "/dashboard",
        icon: "stash:dashboard",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
      },
      {
        label: "Usuarios",
        to: "/usuarios",
        icon: "fa6-solid:users",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.MENTOR],
      },
      {
        label: "Escuelas",
        to: "/escuelas",
        icon: "icon-park-outline:school",
        roles: [ROLES.ADMIN_SYS, ROLES.MENTOR],
      },
      {
        label: "Planteles",
        to: "/planteles",
        icon: "fa7-solid:school",
        roles: [ROLES.ADMIN_SYS],
      },
      {
        label: "Configuración de talentos",
        icon: "mdi:cog-outline",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
        submenu: [
          {
            label: "Talentos",
            to: "/talentos",
            icon: "mdi:star-outline",
          },
          {
            label: "Frases",
            to: "/frases",
            icon: "mdi:format-quote-close",
          },
          {
            label: "Frases de respuesta",
            to: "/frases-respuesta",
            icon: "mdi:message-reply-text-outline",
          },
          {
            label: "Configuración de algoritmo",
            to: "/configurar-algoritmo",
            icon: "hugeicons:algorithm",
          },
          {
            label: "Configuración adicional",
            to: "/configuracion-global-talentos",
            icon: "mdi:earth",
          },
        ],
      },
      {
        label: "Confirmación de talentos",
        icon: "mdi:brain",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
        submenu: [
          {
            label: "Preguntas",
            to: "/preguntas-confirmacion",
            icon: "mdi:help-circle-outline",
          },
          {
            label: "Frases",
            to: "/frases-confirmacion",
            icon: "mdi:message-text-outline",
          },
        ],
      },
    ],
  },
];
